import { ChevronUp } from "../icon-bank/AnimatedIcons";
import { ActionNeededIcon } from "../icon-bank/ActionNeededIcon";
import { TodoProgressGlyph } from "./TodoProgressGlyph";
import { FintheonNumericText } from "../numbers/FintheonNumericText";

interface ChatDrawerPeekProps {
  tone: "status" | "action";
  title: string;
  detail: string;
  onOpen: () => void;
  statusComplete?: boolean;
  statusActive?: boolean;
  doneCount?: number;
  totalCount?: number;
}

export function ChatDrawerPeek({
  tone,
  title,
  detail,
  onOpen,
  statusComplete,
  statusActive,
  doneCount = 0,
  totalCount = 0,
}: ChatDrawerPeekProps) {
  const progressLabel = `${doneCount}/${totalCount} tasks completed`;
  const materialClass =
    tone === "status"
      ? "fintheon-chat-input-drawer--todo-pill fintheon-black-liquid-glass solvys-liquid-glass"
      : "fintheon-chat-input-drawer--action-pill";
  const handleActivate = () => onOpen();
  return (
    <button
      type="button"
      onPointerDown={handleActivate}
      onClick={handleActivate}
      className={`fintheon-chat-input-drawer fintheon-chat-input-drawer--peek ${materialClass}`}
      aria-label={`${title}: ${detail}`}
    >
      <span className="fintheon-chat-input-drawer-peek__content">
        {tone === "action" ? (
          <ActionNeededIcon
            size={16}
            className="shrink-0 text-[var(--fintheon-secondary,var(--fintheon-muted))]"
          />
        ) : (
          <TodoProgressGlyph
            isComplete={!!statusComplete}
            active={!!statusActive}
            doneCount={doneCount}
            totalCount={totalCount}
          />
        )}
        {tone === "action" ? (
          <span className="flex min-w-0 flex-col">
            <span className="text-[10px] font-semibold uppercase tracking-[0.13em] text-[var(--fintheon-accent)]">
              {title}
            </span>
            <span className="truncate text-[11px] leading-4 text-[var(--fintheon-text)]/58">
              {detail}
            </span>
          </span>
        ) : (
          <span className="min-w-0 truncate text-[12px] font-medium text-[var(--fintheon-text)]/66">
            <FintheonNumericText text={progressLabel} />
          </span>
        )}
      </span>
      <span
        className="fintheon-chat-input-drawer-peek__action"
        aria-hidden="true"
      >
        <ChevronUp size={14} />
      </span>
    </button>
  );
}
